import { render, staticRenderFns } from "./SuccessRegistration.vue?vue&type=template&id=5bd6952b&scoped=true"
import script from "./SuccessRegistration.vue?vue&type=script&lang=js"
export * from "./SuccessRegistration.vue?vue&type=script&lang=js"
import style0 from "./SuccessRegistration.vue?vue&type=style&index=0&id=5bd6952b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd6952b",
  null
  
)

export default component.exports